import { useParams } from "react-router-dom";
import { FacilityFormerEmployeesTable } from "./_FacilityFormerEmployeesTable";

export default function FacilityPeopleFormerEmployeesPage() {
  const { facilityId } = useParams();

  return <FacilityFormerEmployeesTable facilityId={facilityId!} />;
}
